import { Quantity } from "@/model/Quantity";

export class ProcessedQuantityRequest{
    cug: string;
    quantity: Quantity;
    totalProcessedQuantity: number;
    totalPrice: number;
    isSubstituted: boolean;

    public constructor(attributes?:Partial<ProcessedQuantityRequest>) {
        Object.assign(this, attributes);
    }
}
